// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Graph Engine API
 * HTTP API for managing Neo4j graph engines.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HandlersPatchGraphEngineInternalResult } from './HandlersPatchGraphEngineInternalResult';
import {
  HandlersPatchGraphEngineInternalResultFromJSON,
  HandlersPatchGraphEngineInternalResultFromJSONTyped,
  HandlersPatchGraphEngineInternalResultToJSON,
  HandlersPatchGraphEngineInternalResultToJSONTyped,
} from './HandlersPatchGraphEngineInternalResult';

/**
 *
 * @export
 * @interface HandlersPatchGraphEnginesInternalResponse
 */
export interface HandlersPatchGraphEnginesInternalResponse {
  /**
   *
   * @type {Array<HandlersPatchGraphEngineInternalResult>}
   * @memberof HandlersPatchGraphEnginesInternalResponse
   */
  results?: Array<HandlersPatchGraphEngineInternalResult>;
}

/**
 * Check if a given object implements the HandlersPatchGraphEnginesInternalResponse interface.
 */
export function instanceOfHandlersPatchGraphEnginesInternalResponse(
  value: object,
): value is HandlersPatchGraphEnginesInternalResponse {
  return true;
}

export function HandlersPatchGraphEnginesInternalResponseFromJSON(
  json: any,
): HandlersPatchGraphEnginesInternalResponse {
  return HandlersPatchGraphEnginesInternalResponseFromJSONTyped(json, false);
}

export function HandlersPatchGraphEnginesInternalResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HandlersPatchGraphEnginesInternalResponse {
  if (json == null) {
    return json;
  }
  return {
    results:
      json['results'] == null
        ? undefined
        : (json['results'] as Array<any>).map(
            HandlersPatchGraphEngineInternalResultFromJSON,
          ),
  };
}

export function HandlersPatchGraphEnginesInternalResponseToJSON(
  json: any,
): HandlersPatchGraphEnginesInternalResponse {
  return HandlersPatchGraphEnginesInternalResponseToJSONTyped(json, false);
}

export function HandlersPatchGraphEnginesInternalResponseToJSONTyped(
  value?: HandlersPatchGraphEnginesInternalResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    results:
      value['results'] == null
        ? undefined
        : (value['results'] as Array<any>).map(
            HandlersPatchGraphEngineInternalResultToJSON,
          ),
  };
}
